import OrmModel from '~/models/abstracts/base/OrmModel'

export default class Permission extends OrmModel {
  static entity = 'permission';

  static fields () {
    return {
      id: this.attr(null),
      key: this.attr(null),
      name: this.attr(null),
      action: this.attr(null),
      object: this.attr(null)
    }
  }

  static ormTrans = {
    single: 'Permission',
    multy: 'Permissions'
  };

  static ormHeaders = [
    //
  ];

  static ormFields = [
    {
      model: 'id'
    },
    {
      model: 'key'
    },
    {
      model: 'name'
    },
    {
      model: 'action'
    },
    {
      model: 'object'
    }
  ];
}
